import { render, staticRenderFns } from "./ClientsRankingCard.vue?vue&type=template&id=2c92d76e&scoped=true"
import script from "./ClientsRankingCard.vue?vue&type=script&lang=js"
export * from "./ClientsRankingCard.vue?vue&type=script&lang=js"
import style0 from "./ClientsRankingCard.vue?vue&type=style&index=0&id=2c92d76e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c92d76e",
  null
  
)

export default component.exports